/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React from 'react'
import {
    ResizableHandle,
    ResizablePanel,
    ResizablePanelGroup,
  } from "@/components/ui/resizable"
  import { useQuery } from "@tanstack/react-query";
import getHospitalData from './getHospitalData';
import HospitalDataTable from './HospitalDataTable';
import HospitalSelectedDetails from './HospitalSelectedDetails';
import { Bold } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Sheet from '../common/Sheet';
import SheetForm from '../common/Sheet';
import HospitalCreateForm from './HospitalCreateForm';

export default function HospitalComp({isOpen}) {
    const [selected, setSelected] = React.useState(null)

    const [addHospitalSheet, setAddHospitalSheet] = React.useState(false)

    const { data: hospital, isFetching: ishospitalFetching } = useQuery({
		queryKey: ["hospital"],
		queryFn: getHospitalData,
		refetchIntervalInBackground: true,
		refetchInterval: 300000,
		refetchOnWindowFocus: true,
		refetchOnMount: true,
	});

    
    const createHospital = async () => {
        try {
            console.log('creating')
        } catch (error) {
            console.log(error)
        }
    }

  return (
    <div style={{width:'100%'}}>
        <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
            <h2 style={{fontWeight: 'bolder'}} className='text-xl'>Hospital Details</h2>
            <Button onClick={() => setAddHospitalSheet(true)}>+ Add Hospital</Button>
        </div>
        
        <div className='mt-[2vh] rounded h-[83vh] '>
            <ResizablePanelGroup
                direction="horizontal"
                className={`max-w-md rounded-lg border ${isOpen ? 'min-w-[80vw]' : 'min-w-[94vw]'}`}
                
                >
                <ResizablePanel defaultSize={50} minSize={40}>
                    {/* <div className="flex h-full items-center justify-center p-6">
                    <span className="font-semibold">Sidebar</span>
                    </div> */}
                    <HospitalDataTable 
                        selected={selected} 
                        setSelected={setSelected} 
                        hospitalData={hospital} 
                        ishospitalFetching={ishospitalFetching}
                    />
                </ResizablePanel>
                <ResizableHandle withHandle />
                <ResizablePanel defaultSize={50} minSize={50}>
                    <HospitalSelectedDetails 
                        selected={selected} 
                        setSelected={setSelected} 
                    />
                </ResizablePanel>
            </ResizablePanelGroup>
        </div>


        <SheetForm 
            open={addHospitalSheet}
            close={setAddHospitalSheet}
            title="Add Hospital"
            description="Create a new hospital/Clinic"
            component={<HospitalCreateForm setAddHospitalSheet={setAddHospitalSheet}/>}
            action={createHospital}

            // setOpen={setAddHospitalSheet}
        />
        
    </div>
  )
}
